const styles = () => ({
    dataGrid: {
      '& .holiday-dates': {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
    },
  });
  export default styles;